function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import arrayEntry from '../fragments/arrayEntry.js';
import simpleBlockContent from '../fragments/simpleBlockContent.js';
import logoCardsGridSectionCard from './logoCardsGridSectionCard.js';
var schema = defineObject('logoCardsGridSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    description: _object_spread({
        title: 'Description'
    }, simpleBlockContent.fragment),
    cards: {
        title: 'Cards',
        type: 'array',
        of: [
            {
                type: 'logoCarouselSectionCard'
            }
        ]
    }
}, [
    logoCardsGridSectionCard.schema.logoCarouselSectionCard
]);
var validator = z.object({
    title: z.string(),
    description: simpleBlockContent.validator,
    cards: z.array(logoCardsGridSectionCard.validator.merge(arrayEntry.validator))
}).partial();
schema.logoCardsGridSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=logoCardsGridSection.js.map